import _ from 'lodash';
import React, { useState } from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import { Button } from 'antd';
import Well from '$components/ProductDashboard/Well';
import CheckoutFormWrapper from '$components/student/ProductUpgrade/CheckoutFormWrapper';
import PartnerJustin from './PartnerJustin';
import FINRA_PRODUCTS from './finraProducts';
import styles from './styles.scss';

const Price = (props) => {
  const { originalPrice, price } = props;
  const showOriginalPrice = originalPrice !== price;

  return (
    <div className={styles.priceLayout}>
      {showOriginalPrice && (
        <div className={styles.originalPrice}>
          {numeral(originalPrice).format('$0,0[.]00')}
        </div>
      )}
      <div className={styles.price}>{numeral(price).format('$0,0[.]00')}</div>
    </div>
  );
};

const Product = (props) => {
  const { product, setSelectedProduct, selected } = props;
  const { shortName, originalPrice, price, discountedPrice, slug } = product;

  return (
    <div className={classnames(styles.product, selected && styles.selected)}>
      <div className={styles.productInfo}>
        <div className={styles.name}>{shortName}</div>
        <Price price={discountedPrice || price} originalPrice={originalPrice} />
      </div>
      <Button
        data-aaa={`selectProduct--${slug}`}
        onClick={() => setSelectedProduct(product)}
        disabled={selected}
      >
        Select
      </Button>
    </div>
  );
};

const Purchase = (props) => {
  const { currentUser, organization } = props;
  const { uuid: organizationUuid, pricingOverrides } = organization;
  const priceOverridesByProductUuid = _.keyBy(pricingOverrides, 'productUuid');
  const products = FINRA_PRODUCTS.map((rawProduct) => {
    const { uuid } = rawProduct;
    const priceOverride = priceOverridesByProductUuid[uuid];
    const product = priceOverride
      ? {
          ...rawProduct,
          price: priceOverride.price,
        }
      : rawProduct;
    product.originalPrice = rawProduct.price;
    return product;
  });

  const [selectedProduct, setSelectedProduct] = useState(products[0]);

  return (
    <div>
      <Well>
        <div className={styles.content}>
          <div className={styles.productsSection}>
            <div className={styles.coursesHeader}>Your pricing</div>
            <div className={styles.products}>
              {products.map((product) => (
                <Product
                  key={product.slug}
                  product={product}
                  setSelectedProduct={setSelectedProduct}
                  selected={product.uuid === selectedProduct.uuid}
                />
              ))}
            </div>
            <div className={styles.coursesAccess}>
              Course access is valid for a year from purchase date.
            </div>
          </div>

          {selectedProduct ? (
            <CheckoutFormWrapper
              key={selectedProduct.slug}
              currentUser={currentUser}
              product={selectedProduct}
              showEnrollmentForm
              organizationUuid={organizationUuid}
            />
          ) : (
            <div>Select a course or bundle.</div>
          )}
        </div>
      </Well>
      <PartnerJustin />
    </div>
  );
};

export default Purchase;
